import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
    providedIn: "root"
})
export class UnsupportedBrowserService {
    private readonly router = inject(Router);

    public checkBrowserSupport(): void {
        const userAgent = navigator.userAgent;
        const internetExplorerRegex = /MSIE|Trident/;

        const isInternetExplorer = internetExplorerRegex.test(userAgent);

        if (isInternetExplorer) {
            this.router.navigateByUrl("/unsupported");
        }
    }
}
